// removed by extract-text-webpack-plugin
module.exports = {"button":"button-3tsac","medium":"medium-2j7B8","default":"default-19tpU","success":"success-1RTXP","error":"error--pZDY","link":"link-Dctyx","filled-success":"filled-success-M1ZzP","filledSuccess":"filled-success-M1ZzP"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/buttons/button/button.less
 ** module id = 162
 ** module chunks = 0
 **/